"use client"

import { Link, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import SEO from './SEO';
const BlogDetail = () => {
  const { slug } = useParams()

const [post, setPost] = useState(null)
const [loading, setLoading] = useState(true)

useEffect(() => {
  const fetchPost = async () => {
    try {
      const res = await fetch(
        `https://mamshospitals.mamscollege.com/wp-json/wp/v2/mams_blogs?slug=${slug}&_embed`
      )
      const data = await res.json()

      if (data.length > 0) {
        setPost(data[0])
      }
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  fetchPost()
}, [slug])

if (loading) return <p>Loading...</p>
if (!post) return <p>Post not found</p>

const image =
  post._embedded?.["wp:featuredmedia"]?.[0]?.source_url
const schema = [
  {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title.rendered,
    "description":
      post.excerpt?.rendered?.replace(/(<([^>]+)>)/gi, "") ||
      "Healthcare blog by MAMS Hospitals",
    "image": image,
    "author": {
      "@type": "Organization",
      "name": "MAMS Hospitals"
    },
    "publisher": {
      "@type": "Organization",
      "name": "MAMS Hospitals",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mamshospitals.com/MAMS-Logo.png"
      }
    },
    "datePublished": post.date,
    "dateModified": post.modified,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://mamshospitals.com/blog/${post.slug}`
    }
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": post.title.rendered,
    "url": `https://mamshospitals.com/blog/${post.slug}`,
    "description":
      post.excerpt?.rendered?.replace(/(<([^>]+)>)/gi, "") ||
      "Healthcare blog by MAMS Hospitals",
    "keywords": [
      post.title.rendered,
      "Healthcare Blog Hyderabad",
      "Medical Article Hyderabad",
      "MAMS Hospitals Blog",
      "Health Tips Hyderabad"
    ]
  }
]
  return (
    <>
  <SEO
    title={`${post.title.rendered} | MAMS Hospitals Blog`}
    description={
      post.excerpt?.rendered?.replace(/(<([^>]+)>)/gi, "") ||
      "Read healthcare blogs and medical articles from MAMS Hospitals."
    }
    keywords={`${post.title.rendered},
healthcare blog Hyderabad,
medical article Hyderabad,
health tips Hyderabad,
hospital blog Hyderabad,
MAMS Hospitals blog`}
    image={image}
    schema={schema}
  />
 <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="bg-primary/5 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <Link
              to="/blog"
              className="inline-flex items-center text-[#096256] font-medium mb-6"
            >
            <svg className="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Blog
          </Link>
          <h1 className="text-3xl md:text-4xl font-semibold text-gray-800 mb-4">{post.title.rendered}</h1>
          <div className="flex flex-wrap items-center gap-4 text-gray-500 text-sm">
            <div className="flex items-center gap-1">
              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                canonicalUrl={`https://mamshospitals.com/blog/${post.slug}`}
      />
              </svg>
              <span>{new Date(post.date).toLocaleDateString("en-IN")}</span>
            </div>
            <div className="flex items-center gap-1">
              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
              <span>By MAMS Hospitals</span>
            </div>
            {/* <div className="flex items-center gap-1">
              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                />
              </svg>
              <span>{post.category}</span>
            </div> */}
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <div className="w-full h-[400px] relative">
         <img
            src={image || "/placeholder.svg"}
            alt={post.title.rendered}
            className="w-full h-full object-cover"
          />
      </div>

      {/* Blog Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="prose prose-lg max-w-none">
            <div className="text-gray-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
          </div>

          {/* Tags */}
          <div className="mt-12 pt-6 border-t border-gray-200">
            <div className="flex flex-wrap gap-2">
              {post.tags && post.tags.length > 0 && (
                <div className="mt-12 pt-6 border-t border-gray-200">
                  <div className="flex flex-wrap gap-2">
                    {post.tags?.length > 0 && (
                      post.tags.map((tag, index) => (
                        <span key={index}>{tag}</span>
                      ))
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Share and Navigation */}
          <div className="mt-12 flex justify-between">
            <Link
                to="/blog"
                className="inline-flex items-center text-[#096256] font-medium"
              >
              <svg className="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Back to Blog
            </Link>
          </div>
        </div>
      </section>
    </div>
    </>
  )
}

export default BlogDetail
